
import { AppState } from '../../../../store';
import { createSelector } from "reselect";

export const HOBSelector = (state: AppState) => state.hob;

export const hobOrgSelector = createSelector(HOBSelector,(item) => item?.orgId?.toUpperCase() || '');
export const hobFlightIdSelector = createSelector(HOBSelector,(item) => item?.flightBookingId || null);
export const hobSourceSelector = createSelector(HOBSelector,(item) => item?.source || null);
export const hobIsDepartureSelector = createSelector(HOBSelector,(item) => item?.isDeparture || null);
export const hobRefIdSelector = createSelector(HOBSelector,(item) => item?.refId || null);
export const hobBookingIdSelector = createSelector(HOBSelector,(item) => item?.bookingId || null);
export const hobPickupTimeSelector = createSelector(HOBSelector,(item) => item?.pickupTime || '');
export const hobDestinationLocationSelector = createSelector(HOBSelector,(item) => item?.destinationLocation || null);
export const useSourceLocationSelector = createSelector(HOBSelector,(item) => item?.useSourceLocation || false);
export const hobSourceLocationSelector = createSelector(HOBSelector,(item) => item?.sourceLocation || null);
export const hobLandingResponseSelector = createSelector(HOBSelector,(item) => item?.hobLandingResponse || null);
export const hobSourceMessageSelector = createSelector(HOBSelector,(item) => item?.source_message || '');
export const hobAirportCityCodeSelector = createSelector(HOBSelector,(item) => item?.airport_city_code || '');
export const hobTerminalSelector = createSelector(HOBSelector,(item) => item?.terminal || '');